import React from "react";
import { css } from "emotion";
import TitleBlock from "../TitleBlock";
import TopRow from "../header/TopRow";

const PlansMobileHeader = () => {
  return (
    <div className={container}>
      <TopRow />
      <TitleBlock
        title="Choose A Plan"
        subtitle="We have multiple plans that fit every business"
      />
    </div>
  );
};

export default PlansMobileHeader;

const container = css`
  padding-bottom: 0;
`;
